import { createBrowserRouter } from "react-router-dom";

import {ROUTER} from "./constants";
import ProductPage from "../pages/ProductPage";
import HelpPage from "../pages/HelpPage";
import RulesPage from "../pages/RulesPage";
import FavoritesPage from "../pages/FavoritesPage";
import DownloadsPage from "../pages/DownloadPage";
import CategoryPage from "../pages/CategoryPage";
import UserPage from "../pages/UserPage";
import SettingPage from "../pages/SettingPage";
import ShowMoreProductPage from "../pages/ShowMoreProductPage";
import ShowMoreCollectionPage from "../pages/ShowMoreCollectionPage";
import ShowSingleCollectionPage from "../pages/ShowSingleCollectionPage";
import InfoSetting from "../pages/InfoSetting";



const routes = createBrowserRouter([
    {
        path: ROUTER.HOME,
        element: <ProductPage />,
    },


    {
        path: ROUTER.HELP,
        element: <HelpPage />,
    },


    {
        path: ROUTER.RULES,
        element: <RulesPage />,
    },

    {
        path: ROUTER.FAVORITES,
        element: <FavoritesPage />,
    },


    {
        path: ROUTER.DOWNLOAD,
        element: <DownloadsPage />,
    },


    {
        path: ROUTER.CATEGORY,
        element: <CategoryPage />,
    },


    {
        path: ROUTER.PROFILE,
        element: <UserPage />,
    },


    {
        path: ROUTER.SETTING,
        element: <InfoSetting />,
    },

    {
        path: ROUTER.SHOW_MORE_PRODUCT,
        element: <ShowMoreProductPage />,
    },

    {
        path: ROUTER.SHOW_MORE_COLLECTION,
        element: <ShowMoreCollectionPage />,
    },

    {
        path: ROUTER.SHOW_SINGLE_COLLECTION,
        element: <ShowSingleCollectionPage />,
    },

    {
        path: ROUTER.SHOW_MORE_SINGLE_COLLECTION,
        element: <ShowMoreProductPage />,
    },


])
export default routes
